<div id="start-menu" class="start-menu d-flex flex-column bg-{{theme.bright}} animate__faster"
  [attr.style]="theme.mainToolbarStyle">
  <!-- Current user -->
  <div id="current-user" class="menu-item p-2" (click)="userClick()">
    <div class="d-flex full-size">
      <div class="media">
        <img [src]="picture" class="mr-3 picture">
        <div class="media-body">
          <span class="text-{{theme.brightContrast}}">{{userName}}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Separator -->
  <div id="space-1" class="flex-grow-1"></div>
  <!-- Settings -->
  <div id="current-user" class="menu-item p-2">
    <div class="d-flex full-size">
      <div class="media">
        <i class="picture fas fa-cog mr-3 text-{{theme.brightContrast}}"></i>
        <div class="media-body">
          <span class="text-{{theme.brightContrast}}">Settings</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Shutdown -->
  <div id="current-user" class="menu-item p-2">
    <div class="d-flex full-size">
      <div class="media">
        <i class="picture fas fa-power-off mr-3 text-{{theme.brightContrast}}"></i>
        <div class="media-body">
          <span class="text-{{theme.brightContrast}}">Power off</span>
        </div>
      </div>
    </div>
  </div>
</div>